import styled from '@emotion/styled';
import { gaps } from 'components/layout/stack';

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${props => {
    if (Array.isArray(props.columns)) {
      return props.columns.map(col => `${col}fr`).join(' ');
    }
    if (props.columns) {
      return `repeat(${props.columns}, 1fr)`;
    }
    return '1fr';
  }};
  gap: ${props => props.gap ? gaps[props.gap] : 'inherit'};
  align-items: ${props => props.alignItems ? props.alignItems : ''};
`;

export default Grid;